module.exports = __webpack_public_path__ + "img/pbj_thumb.bd0521c9.jpg";